import { Editor } from '@tiptap/core'
import { NodeViewProps, NodeViewWrapper } from '@tiptap/react'
import { Fragment, VFC } from 'react'
import { getResourceGlyph } from '@opallabs/gem'
import { useTheme } from '@opallabs/hooks'
import { Icon } from '@opallabs/lapidary'
import { EmbeddedResourceAttributes } from '../..'
import { useEmbeddedResource } from '../useEmbeddedResource'
import { useResourceColor } from '../useResourceColor'
import * as styles from './styles'

export const Inline: VFC<NodeViewProps> = ({ editor, node }) => {
  const theme = useTheme()
  const { href, objectId, objectType } =
    node.attrs as EmbeddedResourceAttributes

  return (
    <NodeViewWrapper
      as="a"
      css={styles.inline(theme)}
      className="embedded-resource-inline-node-view"
      contentEditable={false}
      data-drag-handle
      href={href}
      target="_blank"
      // Links in the editor should not open on click unless we are in view only mode.
      // In edit mode, opening will be handled by the HyperlinkManager.
      onClick={(e: React.MouseEvent) => {
        if (editor.isEditable) {
          e.preventDefault()
        }
      }}
    >
      <InlineNodeContents
        editor={editor}
        href={href}
        objectId={objectId}
        objectType={objectType}
      />
    </NodeViewWrapper>
  )
}

const InlineNodeContents: React.VFC<{
  editor: Editor
  href: string
  objectId: string
  objectType: string
}> = ({ editor, href, objectId, objectType }) => {
  const theme = useTheme()
  const { data: embeddedResource } = useEmbeddedResource(objectId, editor)

  const color = useResourceColor(theme, embeddedResource?.attributes.color)
  const iconGlyph = getResourceGlyph(theme, objectType)

  return (
    <Fragment>
      <span className="embedded-resource-icon">
        <Icon
          ariaHidden={true}
          color={color}
          glyph={iconGlyph}
          height={20}
          width={18}
        />
      </span>

      <span className="embedded-resource-text">
        {embeddedResource?.attributes.title ?? href}
      </span>
    </Fragment>
  )
}
